import useAuthContext from 'app/hooks/useAuthContext';
import useInAppNotifications from 'app/hooks/useInAppNotifications';
import useIsPotManager from 'app/hooks/useIsPotManager';
import useRecognition from 'app/hooks/useRecognition';

/**
 * Unread notifications plus anything else waiting on the employee — the same total the
 * navbar bell shows, so the two never disagree.
 */
function useNotificationBadge(): { count: number; hasUnread: boolean } {
  const { user } = useAuthContext();
  const { isPotManager } = useIsPotManager();

  const { data: unreadNotifications } = useInAppNotifications.useFetchInAppNotifications(
    user?.id
      ? {
          individualId: user.id,
          isRead: false,
          page: 0,
          size: 5,
          sortBy: 'createdAt',
          sort: 'DESC',
        }
      : undefined,
    !!user?.id
  );

  const { data: pendingApprovals } = useRecognition.useListPendingApprovals(
    { page: 0, size: 1 },
    isPotManager
  );

  const unreadCount = unreadNotifications?.total ?? 0;
  const approvalCount = isPotManager ? pendingApprovals?.total ?? 0 : 0;
  const count = unreadCount + approvalCount;

  return { count, hasUnread: count > 0 };
}

export default useNotificationBadge;
